import transform from '@/services/parametrage/filters/paysSeverTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'commun/Pays/';

export async function update(data) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', data);
  return response;
}

export async function create(data) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', data);
  return response;
}

export async function archiver(secteurId, status) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAsync', { ids: [secteurId], archiver: status });
  return response;
}

export async function pGetAll(serverTableData) {
  const inputTable = transform(serverTableData);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputTable);
  return response;
}
export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function remove(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id } });
  return response;
}
